import { computed } from 'vue';

import { AI_ASSISTANT_PRIVILEGE } from '@/constants/ai-privileges';
import { qx_ePlaceType_enum } from '@/graphql/types';
import { useAuthStore } from '@/store/auth';
import type { ScopePlaceRecord } from '@/views/ai/composables/types';

const AI_USAGE_HOME_PLACE_TYPES = new Set<qx_ePlaceType_enum>([
  qx_ePlaceType_enum.Customer,
  qx_ePlaceType_enum.Integrator,
  qx_ePlaceType_enum.Root,
]);

export interface AiUsageAccessInput {
  hasAssistantPrivilege: boolean;
  homePlaceType: qx_ePlaceType_enum | null;
}

export function resolveAiUsageHomePlaceType(root: ScopePlaceRecord): qx_ePlaceType_enum | null {
  return root?.toHomePlaces?.homePlace?.type ?? root?.type ?? null;
}

export function resolveCanViewAiUsage({
  hasAssistantPrivilege,
  homePlaceType,
}: AiUsageAccessInput): boolean {
  return hasAssistantPrivilege && Boolean(homePlaceType && AI_USAGE_HOME_PLACE_TYPES.has(homePlaceType));
}

export function useAiUsageAccess() {
  const auth = useAuthStore();
  const homePlaceType = computed(() =>
    resolveAiUsageHomePlaceType(((auth.scope as any)?.root ?? null) as ScopePlaceRecord),
  );

  const canViewAiUsage = computed(() =>
    resolveCanViewAiUsage({
      hasAssistantPrivilege: auth.user.hasPrivilege(AI_ASSISTANT_PRIVILEGE),
      homePlaceType: homePlaceType.value,
    }),
  );

  return {
    canViewAiUsage,
    homePlaceType,
  };
}
